const appRoutes = {
  DASHBOARD: '/gmat-focus/dashboard',

  //? VIDEOS ROUTE START HERE
  VIDEO_DISPLAY: '/gmat-focus/video-display/:id/:showFreePremium/:type/:chapter_id/:index',
  VIDEO_LESSONS: '/gmat-focus/video-lessons',

  //? QUESTION BANK ROUTE START HERE
  QUESTION_BANK: '/gmat-focus/question-bank',
  QUESTION_BANK_READING: '/gmat-focus/readings/:id',
  QUESTION_BANK_LIST_QUE: '/gmat-focus/view-questions/:chapter_no/:id/:subscriptionstatus/:reading',
  QUESTION_BANK_VIEW_QUE: '/gmat-focus/begin-chapter/:notesid/:readingid/:id/:offset',
  BEGIN_CASE:
    '/gmat-focus/begin-case/:chapterid/:readingid/:caseid/:case_offset/:subscription/:question_number/:offset',
  TAB: '/gmat-focus/gmat-tab/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  GRAPH_MULTI_STATEMENT:
    '/gmat-focus/gmat-multi-statement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  TABLE: '/gmat-focus/gmat-table/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  TWO_PART_STATEMENT:
    '/gmat-focus/gmat-two-part/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  PRACTICE_EXAM: '/gmat-focus/practice_exam',

  //?  QUIZ ROUTE START HERE
  QUIZZES: '/gmat-focus/quiz',
  QUIZZES_BEFORE_START: '/gmat-focus/before-start/:quiz_id/:status_send',
  QUIZZES_BEGIN: '/gmat-focus/begin-quiz-tab/:quiz_id/:offset/:type/:timer',
  BEGIN_QUIZ: '/gmat-focus/begin-quiz/:quiz_id/:offset/:timer',
  BEGIN_CASE_QUIZ: '/gmat-focus/begin-quiz-case/:quiz_id/:offset/:type/:case/:timer',
  BEGIN_TABLE_QUIZ: '/gmat-focus/begin-quiz-table/:quiz_id/:offset/:type/:timer',
  BEGIN_GRAPH_QUIZ: '/gmat-focus/begin-quiz-graph/:quiz_id/:offset/:type/:timer',
  BEGIN_TWO_PART_QUIZ: '/gmat-focus/begin-quiz-two-part/:quiz_id/:offset/:type/:timer',
};

export default appRoutes;



// WEBPACK FOOTER //
// ./src/routes/exams/gmat-focus/app-routes.js